import Skeleton from '@mui/material/Skeleton';

export default function TextLoading({ lines }) {
  return [...Array(lines)].map((_, idx) => <Skeleton key={idx} width={`${WIDTHS[idx % WIDTHS.length]}%`} />);
}

const WIDTHS = [...Array(100)].map(() => Math.random() * 50 + 30);
